import salasService from '../service/salas.service';

export async function carregarSalasPainel({ isAdmin, selectedClienteId, clienteId }) {
  if (isAdmin) {
    return selectedClienteId
      ? salasService.findByCliente(selectedClienteId)
      : salasService.findAll();
  }

  return salasService.findByCliente(clienteId);
}
